import { IRootState } from '@src/domain';
import * as React from 'react';
import { connect } from 'react-redux';
import Flex from 'src/components/legos/primitives/Flex';
import Text from 'src/components/legos/primitives/Text';
import UserAvatar from '../UserAvatar';
import Box from '../primitives/Box';
import ButtonLink from '../ButtonLink';

const mapStateToProps = (state: IRootState) => ({
  user: state.User.user,
});

const AvatarInput: React.FC<ReturnType<typeof mapStateToProps>> = ({ user }) => {
  if (!user) {
    return null;
  }
  return (
    <Box flex='0 0 auto' mb={5}>
      <Text fontSize={2}>Avatar</Text>
      <Flex alignItems='center' mt={2}>
        <UserAvatar
          email={user.email}
          size={60}
        />
        <ButtonLink
          href='https://en.gravatar.com/emails/'
          ml={3}
          size='sm'
          target='_blank'
        >
          Change Avatar
        </ButtonLink>
      </Flex>
    </Box>
  );
};

export default connect(mapStateToProps)(AvatarInput);
